import {slugsFor} from './content-registry';

/**
 * Which commercial use-case page owns each /learn topic. Used by the homepage feature wall
 * (tiles route here instead of the guide) and by the learn pages themselves (the "using this
 * for real?" band). Kept as one map so the funnel stays consistent in both directions.
 */
export const COMMERCIAL_TARGETS: Record<string, string> = {
    'play-logging': 'play-tracker',
    'statistics': 'board-game-stats',
    'collection': 'board-game-collection',
    'shops-prices': 'board-game-prices',
    'search-discovery': 'find-players',
    'scheduled-games': 'game-night-planner',
    'ticketing': 'event-ticketing',
    'tournaments': 'tournament-software',
    'integrations': 'bgg-sync',
};

/**
 * The commercial page path for a learn slug, or null when the topic has no use-case page or
 * this locale has no authored version of it — so no locale ever links into a guarded 404.
 */
export function commercialLinkFor(learnSlug: string, locale: string): string | null {
    if (learnSlug === 'public-api' && slugsFor('developers', locale).includes('api')) {
        return '/developers/api';
    }
    const target = COMMERCIAL_TARGETS[learnSlug];
    return target && slugsFor('use-case', locale).includes(target) ? '/' + target : null;
}
